export var ArmyOptionType;
(function (ArmyOptionType) {
    // Units must be included in the army
    // This limits a set of units from min - max
    ArmyOptionType[ArmyOptionType["MustBeIncluded"] = 0] = "MustBeIncluded";
    // Unit is required to be the general
    ArmyOptionType[ArmyOptionType["RequiredGeneral"] = 1] = "RequiredGeneral";
    // Unit must be the general, but only if they are included
    ArmyOptionType[ArmyOptionType["GeneralIfIncluded"] = 2] = "GeneralIfIncluded";
    // A unit must be the general if they are included as a hero
    // This is only used if the unit is not typically a hero,
    // otherwise use GeneralIfIncluded
    ArmyOptionType[ArmyOptionType["GeneralIfHero"] = 3] = "GeneralIfHero";
    ArmyOptionType[ArmyOptionType["OnePerX"] = 4] = "OnePerX";
    // who knows
    ArmyOptionType[ArmyOptionType["Custom"] = 5] = "Custom";
})(ArmyOptionType || (ArmyOptionType = {}));
export const armyOptionTypeToString = (type) => {
    switch (type) {
        case ArmyOptionType.MustBeIncluded:
            return 'mustBeIncluded';
        case ArmyOptionType.RequiredGeneral:
            return 'requiredGeneral';
        case ArmyOptionType.GeneralIfIncluded:
            return 'generalIfIncluded';
        case ArmyOptionType.GeneralIfHero:
            return 'generalIfHero';
        case ArmyOptionType.OnePerX:
            return 'onePerX';
    }
    return 'custom';
};
